import { Div } from "../../../base/components/native/div"
import { emitter } from "../../../services/emitter"
import * as styles from "./status.style"

export const Status = () => {

    const base = Div()
    base.cssClass(styles.baseStyle)

    const dot = Div()
    dot.cssClass(styles.dotStyle)
    base.append(dot)

    const message = Div('Connecting...')
    message.cssClass(styles.messageStyle)
    base.append(message)

    emitter.on('ws-connected', () => {
        dot.el.classList.remove('error');
        dot.el.classList.add('success');
        message.text('Connected');
    });

    emitter.on('ws-disconnected', () => {
        dot.el.classList.remove('success');
        dot.el.classList.add('error');
        message.text('Disconnected');
    })
    
    return base
}